import React from 'react';
import PropTypes from 'prop-types';
import ShortId from 'shortid';
import HeadingActions from '../../components/HeadingActions';

export const PageLinks = props => {
  return (
    <HeadingActions
      key={ShortId.generate()}
      isDirty={props.isDirty}
      editPath={`/custom-service-request/${props.serviceRequestId}`}
      changeHistoryPath={props.changeHistoryPath}
      historyPath={
        props.isEdit &&
        `/custom-service-request-history/${props.serviceRequestId}`
      }
      discussion={{
        ...props.discussion,
        iconOnly: true,
        serviceRequestId: props.serviceRequestId
      }}
    />
  );
};

PageLinks.propTypes = {
  partyId: PropTypes.string,
  changeHistoryPath: PropTypes.string,
  serviceRequestId: PropTypes.string,
  discussion: PropTypes.object,
  isEdit: PropTypes.bool,
  isDirty: PropTypes.bool
};
